// @flow
import * as React from 'react';
import cx from 'classnames';

import cs from './styles.pcss';
import t from './locale';

type Props = {
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
  children: React.Node,
  selected?: boolean,
  innerRef?: React.Ref<any>,
  className?: string,
  focused?: boolean,
  notFound?: boolean,
  onMouseDown?: (event: SyntheticMouseEvent<HTMLElement>) => void,
  onMouseEnter?: () => void,
  hidden?: boolean,
};

export default function DropdownOption({
  onClick,
  children,
  selected = false,
  innerRef,
  className,
  focused,
  notFound,
  onMouseDown,
  onMouseEnter,
  hidden,
}: Props): React.Node {
  const renderContent = () => {
    if (notFound) {
      return <div className={cs.optionText}>{t('notFound')}</div>;
    }

    return (
      <>
        <div
          className={cx(cs.optionText, { [cs.selectedOptionText]: selected })}
        >
          {children}
        </div>
        {selected && (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cs.selected}
          >
            <path
              d="M13.1132 3.32254C13.5448 2.89249 14.2446 2.89249 14.6763 3.32254C15.1079 3.75259 15.1079 4.44984 14.6763 4.87989L6.52632 13L1.32372 7.81646C0.892092 7.38641 0.892092 6.68916 1.32372 6.25911C1.75536 5.82906 2.45517 5.82906 2.8868 6.25911L6.52632 9.88529L13.1132 3.32254Z"
              fill="currentColor"
            />
          </svg>
        )}
      </>
    );
  };

  if (hidden) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cx(cs.option, className, {
        [cs.focused]: focused,
        [cs.notFound]: notFound,
      })}
      ref={innerRef}
      onMouseDown={onMouseDown}
      onMouseEnter={onMouseEnter}
    >
      {renderContent()}
    </button>
  );
}
